import { Package, Globe } from "lucide-react";
import Reveal from "./Reveal";

const SERVICES = [
  {
    icon: Package,
    title: "EXPORT (Sourcing from India)",
    intro:
      "We identify, vet, and manage suppliers across India for: Apparel & textiles, leather goods & bags, footwear, fashion jewellery & watches, packaged food & FMCG.",
    steps: [
      "Product sourcing & sampling",
      "Quality inspection & compliance",
      "Consolidation & export packaging",
      "Documentation & shipping (FOB/CIF/DDP)",
    ],
    accent: "border-accent/40",
    iconBg: "bg-accent/15",
    iconColor: "text-accent",
  },
  {
    icon: Globe,
    title: "IMPORT (Sourcing for India)",
    intro:
      "We also assist Indian businesses in importing select categories — watches, accessories, specialty food items, and branded goods — from international suppliers.",
    steps: [
      "Supplier identification abroad",
      "Import documentation & customs clearance",
      "Warehousing in India",
      "Distribution to retail/wholesale partners",
    ],
    accent: "border-accent-2/40",
    iconBg: "bg-accent-2/15",
    iconColor: "text-accent-2",
  },
];

export default function TradeServices() {
  return (
    <section id="trade-services" className="section-shell bg-surface/40">
      <div className="section-inner">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-8 md:mb-10">
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary tracking-tight">
              How We Trade
            </h2>
            <div className="w-16 h-1 bg-accent mx-auto mt-5 rounded-full" />
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {SERVICES.map((service, i) => {
            const Icon = service.icon;
            return (
              <Reveal key={service.title} delay={i * 100}>
                <article
                  className={`h-full bg-surface border-2 ${service.accent} rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow`}
                >
                  <div className={`w-14 h-14 rounded-xl ${service.iconBg} flex items-center justify-center mb-5`}>
                    <Icon size={26} className={service.iconColor} />
                  </div>
                  <h3 className="font-serif text-xl md:text-2xl font-bold text-primary">{service.title}</h3>
                  <p className="mt-4 text-sm text-muted leading-relaxed">{service.intro}</p>
                  <ul className="mt-6 space-y-3">
                    {service.steps.map((step) => (
                      <li key={step} className="flex items-start gap-2.5 text-sm text-primary">
                        <span className="w-1.5 h-1.5 rounded-full bg-accent mt-2 shrink-0" />
                        {step}
                      </li>
                    ))}
                  </ul>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
